(function (ws) {
    'use strict';

    ws.models.shippingZipcode = Backbone.Model.extend({
        /**
         * Initialize override to include model options
         * @param {Object} options
         */
        initialize: function(options) {
            this.options = options;
        },

        /**
         * Build URL based on passed zip code in options
         * @returns {string}
         */
        url: function() {
            return globals.path.api.quoting.getAddressByZip + '?zip=' + this.options.zip;
        }
    });
}(westcon));
